import { IAttribute, IProductWithAttributes } from '@gn-audio/core/api/product-catalogue/models';
import { CustomizerFilter } from '../models';

const matchGroupByFilters = (group: IProductWithAttributes, filters: CustomizerFilter[]): boolean => {
  return filters
    .filter((f: CustomizerFilter): boolean => f.available)
    .filter((f: CustomizerFilter): boolean => f.hasValue)
    .every((f: CustomizerFilter): boolean => {
      return group.attributes.some((a: IAttribute) => a.key === f.name && a.valueKey === f.value);
    });
};

export const filterGroupsByFilters = (groups: IProductWithAttributes[], filters: CustomizerFilter[]): IProductWithAttributes[] => {
  const matched: IProductWithAttributes[] = [];

  for (const group of groups) {
    if (matchGroupByFilters(group, filters)) {
      matched.push(group);
    }
  }

  return matched;
};